import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
//import {WebcamModule} from 'ngx-webcam';
//import { EllipsisModule } from 'ngx-ellipsis';
//import { PdfViewerModule } from 'ng2-pdf-viewer';
import { QRCodeModule } from 'angularx-qrcode';

import { TableComponent, WalletPreviewComponent, /*WebCamComponent,*/ CardPreviewComponent, FrameFeatureComponent, FrameIconsComponent, WeblinkModalAnimateComponent, FrameProfileComponent,WalletIconsComponent,GwalletPreviewComponent } from '@app/components'
import { CardPreviewService, SafePipe } from './card-preview';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QRCodeModule
    /*WebcamModule,
    EllipsisModule,
    PdfViewerModule*/
  ],
  declarations: [
    TableComponent,
    //WebCamComponent,
    CardPreviewComponent,
    FrameFeatureComponent,
    FrameIconsComponent,
    WeblinkModalAnimateComponent,
    FrameProfileComponent,
    SafePipe,
    WalletPreviewComponent,
    WalletIconsComponent,
    GwalletPreviewComponent
  ],
  exports: [
    TableComponent,
    //WebCamComponent,
    CardPreviewComponent,
    FrameFeatureComponent,
    FrameIconsComponent,
    WeblinkModalAnimateComponent,
    FrameProfileComponent,
    WalletPreviewComponent,
    WalletIconsComponent,
    GwalletPreviewComponent
  ],
  providers: [
    CardPreviewService
  ]
})
export class ComponentsModule { }